import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui/button';
import { GraduationCap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function MasterClassEmpty() {
  useLanguage();
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mb-6">
        <GraduationCap className="h-10 w-10 text-primary" />
      </div>
      <h3 className="text-xl font-semibold mb-2">
        {translateInterfaceText("Nenhuma aula encontrada")}</h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        {translateInterfaceText("Não encontramos aulas com os filtros selecionados. Tente ajustar sua busca ou explorar outras categorias.")}</p>
      <Button onClick={() => navigate('/dashboard')}>
        {translateInterfaceText("Voltar ao Dashboard")}</Button>
    </div>
  );
}
